import { AppThemeProvider, defaultTheme } from '@hqo/react-components-library/dist/molecules/theme';
import { HqoThemeProvider } from '@hqo/react-components-library/dist/hqo-theme-provider';
import { DeviceProvider } from '@hqo/react-components-library/dist/device';
import { library } from '@fortawesome/fontawesome-svg-core';
// Import only the specific icons used in the app to reduce bundle size (~8MB -> ~10KB)
import { faCreditCard, faArrowLeft, faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import {
  faDumbbell,
  faTimes,
  faCalendarAlt,
  faCalendar as faCalendarSolid,
  faTrash,
  faQrcode,
  faAsterisk,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faAngleUp,
  faAngleDown,
  faCalendar as faCalendarLight,
  faCalendarTimes,
  faMapMarkerAlt,
  faCalendarAlt as faCalendarAltLight,
  faPhone,
  faEmptySet,
} from '@fortawesome/pro-light-svg-icons';

import { App } from 'components/app';
import { BrowserRouter } from 'react-router-dom';
import { CHECKOUT_BREAK_POINT } from 'shared/consts';
import { ConnectedRouter } from 'connected-react-router';
import { IntlProvider } from 'components/intl-provider';
import LaunchDarklyInitializer from 'components/launchdarkly/LaunchDarklyInitializer';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { RootStyles } from 'components/root/root.styles';
import { history } from 'store/router/history';
import store from 'store';
import { MiniappSdkProvider } from 'components/miniapp-sdk-provider';

library.add(
  // pro-regular icons
  faCreditCard,
  faArrowLeft,
  faExclamationTriangle,
  // pro-solid icons
  faDumbbell,
  faTimes,
  faCalendarAlt,
  faCalendarSolid,
  faTrash,
  faQrcode,
  faAsterisk,
  // pro-light icons
  faAngleUp,
  faAngleDown,
  faCalendarLight,
  faCalendarTimes,
  faMapMarkerAlt,
  faCalendarAltLight,
  faPhone,
  faEmptySet,
);

export const Root: React.FC = (): JSX.Element => (
  <ReduxProvider store={store}>
    <MiniappSdkProvider>
      <LaunchDarklyInitializer>
        <HqoThemeProvider>
          <DeviceProvider smallDeviceMaxWidth={CHECKOUT_BREAK_POINT}>
            <AppThemeProvider theme={defaultTheme}>
              <RootStyles />
              <BrowserRouter>
                <ConnectedRouter history={history}>
                  <IntlProvider>
                    <App />
                  </IntlProvider>
                </ConnectedRouter>
              </BrowserRouter>
            </AppThemeProvider>
          </DeviceProvider>
        </HqoThemeProvider>
      </LaunchDarklyInitializer>
    </MiniappSdkProvider>
  </ReduxProvider>
);
